import { z } from "zod";

export const DateTimeString_Schema = z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, "Datetime is expected in YYYY-MM-DD HH:mm:ss format.");

// 2024-12-31
export const DateString_Schema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date is expected in YYYY-MM-DD format.");

// 2024-12-31T23:59:59+00:00
export const DateTimeIso8601_Schema = z.iso.datetime({ offset: true }).transform((value) => new Date(value));

/** Including zero */
export const WholeNumber_Schema = z.number().int("Expected whole number.").nonnegative("Expected zero or greater value.");

export const NaturalNumber_Schema = z.number().int("Expected whole number.").positive("Expected positive value.");

/**
 * We are ignoring the timezone for now!!!
 */
export const DateTimeObject_Schema = z
  .object({
    date: z.string(),
    timezone: z.string(),
    timezone_type: z.number(),
  })
  .transform((val) => {
    const isoLike = val.date.replace(" ", "T");
    return new Date(isoLike);
  })
  .refine((d) => !isNaN(d.getTime()), { message: "Invalid Date" });

export type DateTimeObject = z.infer<typeof DateTimeObject_Schema>;
